// src/App.js
import './index.css';   // Tailwind (if you use it here)
import './App.css';     // Your overrides LAST so they win

import React, { useState, useEffect } from 'react'
import { ClipLoader } from 'react-spinners'

import { Amplify } from 'aws-amplify'
import awsExports from './aws-exports'
import HomeModern from './HomeModern'
import { Hub } from '@aws-amplify/core'
import { getCurrentUser, signOut } from '@aws-amplify/auth'
import { Authenticator } from '@aws-amplify/ui-react'
import '@aws-amplify/ui-react/styles.css'
import Blog from "./Blog"
import api, { apiPost } from "./apiClient";
import { fetchEntitlements, subscribe } from './paymentsClient'   // <-- NEW
import CreditsBadge from './CreditsBadge'              // <-- NEW
import LanguageSelector from './LanguageSelector'
import { tUI } from './i18n'
import { getSeo, canonicalUrl, hreflangAlternates } from './seoConfig';
import { About } from './About'
import { Pricing } from './Pricing'
import Features from './Features'
import CVEditor from './CVEditor'
import CVHtmlPreview from './CVHtmlPreview'


Amplify.configure(awsExports)

const SUPPORTED_SITE_LANGS = ["en", "fr", "de", "it", "es"];

function detectInitialSiteLanguage() {
  // 1) URL language must win for SEO and localized pages:
  // /en/, /de/, /fr/, /it/, /es/
  if (typeof window !== "undefined") {
    const pathLang = window.location.pathname.split("/")[1]?.toLowerCase();

    if (SUPPORTED_SITE_LANGS.includes(pathLang)) {
      window.localStorage.setItem("yscv_site_lang", pathLang);
      return pathLang;
    }
  }

  // 2) If there is no language in the URL, use previous user choice
  if (typeof window !== "undefined") {
    const stored = window.localStorage.getItem("yscv_site_lang");

    if (stored && SUPPORTED_SITE_LANGS.includes(stored)) {
      return stored;
    }
  }

  // 3) Otherwise, use browser language
  if (typeof navigator !== "undefined") {
    const navLang = (navigator.language || navigator.userLanguage || "en")
      .split("-")[0]
      .toLowerCase();

    if (SUPPORTED_SITE_LANGS.includes(navLang)) {
      return navLang;
    }
  }

  // 4) Fallback
  return "en";
}

const CANONICAL_ORIGIN = "https://www.yoursmartcv.com";
const BLOG_ORIGIN = "https://blog.yoursmartcv.com";
const READY_BLOG_LANGS = ["en", "de","fr", "it", "es"]; // add fr, it, es later when ready

function getBlogUrl(lang) {
  const normalized = (lang || "en").toLowerCase();

  if (normalized === "en") {
    return `${BLOG_ORIGIN}/en/`;
  }

  if (normalized === "de") {
    return READY_BLOG_LANGS.includes("de")
      ? `${BLOG_ORIGIN}/de/`
      : `${BLOG_ORIGIN}/en/`;
  }

  if (normalized === "fr") {
    return READY_BLOG_LANGS.includes("fr")
      ? `${BLOG_ORIGIN}/fr/`
      : `${BLOG_ORIGIN}/en/`;
  }

  if (normalized === "it") {
    return READY_BLOG_LANGS.includes("it")
      ? `${BLOG_ORIGIN}/it/`
      : `${BLOG_ORIGIN}/en/`;
  }

  if (normalized === "es") {
    return READY_BLOG_LANGS.includes("es")
      ? `${BLOG_ORIGIN}/es/`
      : `${BLOG_ORIGIN}/en/`;
  }

  return `${BLOG_ORIGIN}/en/`;
}

function upsertLink(rel, href, extraAttrs = {}) {
  let link = document.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", rel);
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
  Object.entries(extraAttrs).forEach(([k, v]) => link.setAttribute(k, v));
}



  function setUrlForSection(section, lang) {
  const l = (lang || "en").toLowerCase();
  const base = `/${l}`;

  if (!section) {
  window.history.pushState({}, "", `/${l}/`);
  return;
  }


  if (section === "about") window.history.pushState({}, "", `${base}/about`);
  if (section === "pricing") window.history.pushState({}, "", `${base}/pricing`);
  if (section === "blog") window.history.pushState({}, "", `${base}/blog`);

}



export default function App() {
  const [user, setUser]                   = useState(null)
  const [showAuthModal, setShowAuthModal] = useState(false)
  const [openSection, setOpenSection]     = useState(null)

  const [service, setService]             = useState(null)
  const [siteLanguage, setSiteLanguageState] = useState(() => detectInitialSiteLanguage())  // site‐wide UI lang
  // ✅ SEO + URL sync for Google (canonical + hreflang)
  

  
  const [cvLanguage, setCvLanguage]       = useState(() => detectInitialSiteLanguage())     // CV builder lang

  // Change site language everywhere + remember choice
function setSiteLanguage(lang) {
  const normalized = SUPPORTED_SITE_LANGS.includes(lang) ? lang : "en";

  setSiteLanguageState(normalized);
  setCvLanguage(normalized); // keep CV builder default aligned

  if (typeof window !== "undefined") {
    window.localStorage.setItem("yscv_site_lang", normalized);
  }
  // ✅ add this:
  setUrlForSection(openSection, normalized);
}

function goTo(section) {
  setOpenSection(section);
  setUrlForSection(section, siteLanguage);
  window.dispatchEvent(new PopStateEvent("popstate"));
}








  const [file, setFile]                   = useState(null)
  const [jd, setJd]                       = useState('')
  const [parsedData, setParsedData]       = useState(null)
  const [editedData, setEditedData]       = useState(null)
  const [loading, setLoading]             = useState(false)
  const [error, setError]                 = useState('')
  const [downloadUrl, setDownloadUrl]     = useState('')
  const [coverLoading, setCoverLoading]   = useState(false)
  const [previewPdfUrl, setPreviewPdfUrl] = useState('')

  useEffect(() => {
    if (typeof window === "undefined") return;

    const params = new URLSearchParams(window.location.search);

    if (params.get("success") === "1") {
      if (window.gtag) {
        window.gtag("event", "purchase", {
          transaction_id: `stripe_${Date.now()}`,
          currency: "EUR",
          value: 24.99,
          plan: "premium",
          page_path: window.location.pathname,
          language: siteLanguage,
          items: [
            {
              item_id: "premium",
              item_name: "Premium CV Builder",
              price: 24.99,
              quantity: 1,
            },
          ],
        });
      }

      // Clean URL so refresh does not send purchase again
      window.history.replaceState({}, "", `/${siteLanguage}/pricing`);
    }

    if (params.get("canceled") === "1") {
      if (window.gtag) {
        window.gtag("event", "checkout_canceled", {
          currency: "EUR",
          value: 24.99,
          plan: "premium",
          page_path: window.location.pathname,
          language: siteLanguage,
        });
      }

      window.history.replaceState({}, "", `/${siteLanguage}/pricing`);
    }
  }, [siteLanguage]);


  // NEW: entitlements (for button gating)
  const [ent, setEnt] = useState(null)
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const loadSignedInState = async () => {
const u = await getCurrentUser();
  setUser(u);

  let e = null;

  for (let i = 0; i < 6; i++) {
    e = await fetchEntitlements();

    const looksLikeGuestFallback =
      e?.status === "inactive" &&
      e?.plan === "none" &&
      (e?.quota_monthly ?? 0) === 0 &&
      (e?.quota_used_month ?? 0) === 0;

    if (!looksLikeGuestFallback) {
      break;
    }

    await sleep(700);
  }

  setEnt(e);

  const active =
    e?.status === "active" &&
    e?.plan &&
    e.plan !== "none";

  setOpenSection(active ? null : "pricing");
  setShowAuthModal(false);

  if (active) {
    const lang = siteLanguage || "en";
    const path = window.location.pathname || "/";
    if (path.includes("/pricing")) {
      window.history.replaceState({}, "", `/${lang}`);
    }
  }
};
  
  
  

  // Load user + entitlements on start, and on auth changes
    // Load user + entitlements on start, and handle login/logout events
  useEffect(() => {
        const loadUserAndEnt = async () => {
      try {
        await loadSignedInState();
      } catch (err) {
        setUser(null);
        setEnt(null);
      }
    };
    // const loadUserAndEnt = async () => {
    //   try {
    //     const u = await getCurrentUser()
    //     setUser(u)

    //     // try {
    //     //   const e = await fetchEntitlements()
    //     //   setEnt(e)

    //     //   const active =
    //     //     e?.status === 'active' &&
    //     //     e?.plan &&
    //     //     e.plan !== 'none'

    //     //   // 🔹 On initial page load:
    //     //   // - If user already signed in and ACTIVE -> show workspace (home)
    //     //   // - If user signed in but NO active plan -> you can choose:
    //     //   //   either land on pricing or on home. Let's keep home here.
    //     //   if (active) {
    //     //     setOpenSection(null) // workspace / normal home
    //     //   } else {
    //     //     // don't force pricing on reload; user can click Pricing from nav
    //     //     // setOpenSection('pricing')
    //     //   }
    //     // } catch (err) {
    //     //   console.error('Failed to load entitlements on startup', err)
    //     // }
    //     // only fetch entitlements if signed in
    //     /// super importan keep it layter
    //   // try {
    //   //   const e = await fetchEntitlements();
    //   //   setEnt(e);
    //   // } catch (err) {
    //   //   console.error("Failed to load entitlements on startup", err);
    //   // }

    //     try {
    //     const e = await fetchEntitlements();
    //     setEnt(e);

    //     const active =
    //       e?.status === "active" &&
    //       e?.plan &&
    //       e.plan !== "none";

    //     if (active) {
    //       setOpenSection(null);

    //       const path = window.location.pathname || "/";
    //       if (path.includes("/pricing")) {
    //         const lang = siteLanguage || "en";
    //         window.history.replaceState({}, "", `/${lang}`);
    //       }
    //     }
    //   } catch (err) {
    //     console.error("Failed to load entitlements on startup", err);
    //   }
    //   } catch {
    //     setUser(null);
    //     setEnt(null);
    //   }
    // }

    loadUserAndEnt()

    // const unsub = Hub.listen('auth', async ({ payload }) => {
    //   if (payload.event === 'signOut') {
    //     setUser(null)
    //     setEnt(null)
    //     setOpenSection(null)  // back to public landing
    //   } else if (payload.event === 'signIn' || payload.event === 'signedIn') {
    //     try {
    //       const u = await getCurrentUser()
    //       setUser(u)

    //       const e = await fetchEntitlements()
    //       setEnt(e)

    //       const active =
    //         e?.status === 'active' &&
    //         e?.plan &&
    //         e.plan !== 'none'

    //       // 🔹 SIGNED IN JUST NOW:
    //       // - Active plan    -> go to Home (workspace + 3 circles)
    //       // - No active plan -> go to Pricing ONCE (they can still change via nav)
    //       setOpenSection(active ? null : 'pricing')
          
    //     } catch (err) {
    //       console.error('Error after sign-in', err)
    //     }
    //   }
    // })
        const unsub = Hub.listen("auth", async ({ payload }) => {
      if (payload.event === "signOut") {
        setUser(null);
        setEnt(null);
        setOpenSection(null);
        setShowAuthModal(false);
        return;
      }

      if (payload.event === "signIn" || payload.event === "signedIn") {
        try {
          if (typeof window !== "undefined" && window.gtag) {
            window.gtag("event", "login", {
              method: "cognito",
              page_path: window.location.pathname,
              language: siteLanguage,
            });
          }

          await loadSignedInState();
        } catch (err) {
          console.error("Error after sign-in", err);
        }
      }
    });

    return unsub
  }, [])

  useEffect(() => {
    if (typeof window === "undefined") return;

    // Blog component manages its own SEO — don't fight it.
    if (openSection === "blog") return;

    // 1) Decide the active route key
    let routeKey = "home";
    if (openSection === "pricing") routeKey = "pricing";
    else if (openSection === "about") routeKey = "about";

    // 2) Pick the localized title + description for THIS language
    const lang = (siteLanguage || "en").toLowerCase();
    const seo = getSeo(routeKey, lang);

    // Set <title>
    document.title = seo.title;

    // Set <meta name="description">
    let descMeta = document.querySelector('meta[name="description"]');
    if (!descMeta) {
      descMeta = document.createElement("meta");
      descMeta.setAttribute("name", "description");
      document.head.appendChild(descMeta);
    }
    descMeta.setAttribute("content", seo.description);

    // 3) Open Graph + Twitter
    const canonical = canonicalUrl(routeKey, lang);

    const setMeta = (selector, attr, value) => {
      let m = document.querySelector(selector);
      if (!m) {
        m = document.createElement("meta");
        const key = selector.includes('property=') ? 'property' : 'name';
        const val = selector.match(/=["']([^"']+)["']/)?.[1];
        if (val) m.setAttribute(key, val);
        document.head.appendChild(m);
      }
      m.setAttribute(attr, value);
    };

    setMeta('meta[property="og:title"]', "content", seo.title);
    setMeta('meta[property="og:description"]', "content", seo.description);
    setMeta('meta[property="og:url"]', "content", canonical);
    setMeta('meta[name="twitter:title"]', "content", seo.title);
    setMeta('meta[name="twitter:description"]', "content", seo.description);

    // 4) Canonical — always the localized URL for this route
    upsertLink("canonical", canonical);

    // 5) hreflang alternates — fully rebuilt
    document
      .querySelectorAll('link[rel="alternate"][hreflang]')
      .forEach((n) => n.remove());

    hreflangAlternates(routeKey).forEach(({ hreflang, href }) => {
      const link = document.createElement("link");
      link.setAttribute("rel", "alternate");
      link.setAttribute("hreflang", hreflang);
      link.setAttribute("href", href);
      document.head.appendChild(link);
    });

    // 6) Keep <html lang="..."> in sync
    document.documentElement.setAttribute("lang", lang);
  }, [openSection, siteLanguage]);






  // Listen for global entitlements refresh (emitted after successful API calls)
  useEffect(() => {
    const h = async () => {
      try { setEnt(await fetchEntitlements()) } catch {}
    }
    window.addEventListener('refresh-entitlements', h)
    return () => window.removeEventListener('refresh-entitlements', h)
  }, [])

  const requireAuth = section => {
    if (!user) setShowAuthModal(true)
    else       setOpenSection(openSection === section ? null : section)
  }

  useEffect(() => {
    const syncSectionFromPath = () => {
      const path = window.location.pathname;

      // Blog: /en/blog or /en/blog/slug
      if (path.match(/^\/(en|fr|de|it|es)\/blog(\/.*)?$/)) {
        setOpenSection("blog");
        return;
      }

      // Static sections: /en/about, /en/pricing, /en/services
      const m = path.match(/^\/(en|fr|de|it|es)\/(about|pricing)\/?$/);

      if (m) {
        setOpenSection(m[2]);
        return;
      }

      // default home
      setOpenSection(null);
    };

    syncSectionFromPath();
    window.addEventListener("popstate", syncSectionFromPath);
    return () => window.removeEventListener("popstate", syncSectionFromPath);
  }, []);



  // NEW: gate UI based on plan status (active this month)
  const hasActivePlan =
    !!ent &&
    ent.status === 'active' &&
    ent.plan &&
    ent.plan.toLowerCase() !== 'none';

  const canUse =
    hasActivePlan &&
    (ent?.quota_monthly ?? 0) > (ent?.quota_used_month ?? 0);

 


  // // NEW: gate UI based on credits
  // const canUse =
  //   ent?.status === 'active' &&
  //   (ent?.quota_monthly ?? 0) > (ent?.quota_used_month ?? 0)

  // const hasActivePlan =
  //   ent?.status === 'active' &&
  //   ent?.plan &&
  //   ent.plan !== 'none';

  // Has this user ever had a paid plan (even if canceled/expired)?
  const hasEverPaid =
    !!ent && ent.plan && ent.plan !== 'none';

  // NEW: current plan key ('standard' | 'advanced' | 'premium' | 'none')
  const currentPlan = ent?.plan || 'none';


  const handleConvert = async () => {
    if (!file) return
    setError(''); setLoading(true)
    try {
      // Optional pre-check (backend still enforces)
      if (!canUse) {
        setError('You’ve reached the Fair Use limit for normal personal use. Please wait for your monthly renewal or upgrade to a Premium plan.')
        return
      }

      // 1) Quick parse to detect CV language
      const detectForm = new FormData()
      detectForm.append('file', file)
      detectForm.append('language', cvLanguage)
      const detectRes = await apiPost('/debug_convert_cv', detectForm, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      const detectedLang = detectRes.data.language || cvLanguage
      console.log(`[handleConvert] detected CV language=${detectedLang}`)
      setCvLanguage(detectedLang)
      setParsedData(detectRes.data)
      setEditedData(detectRes.data)

      // 2) Actual convert with correct CV language 
      const form = new FormData()
      form.append('file', file)
      form.append('language', detectedLang)
      let endpoint = '/convert_cv'
      if (service === 'ai_matching') {
        form.append('job_description', jd)
        endpoint = '/convert_with_jd'
      }
      const res = await apiPost(endpoint, form, {
        headers: { 'Content-Type':'multipart/form-data' },
        timeout: 580000, // 90 seconds for AI Matching (convert_with_jd)
      })
      setDownloadUrl(res.data.download_url)

      // ✅ Tell badge + any listeners to refresh credits
      window.dispatchEvent(new Event('refresh-entitlements'))
      try { setEnt(await fetchEntitlements()) } catch {}
        } catch (e) {
      console.error("Convert error", e);

      const detail =
        e?.response?.data?.detail ||
        e?.response?.data?.error ||
        e?.message ||
        e?.toString();

      setError(detail || 'Conversion failed.');
    } finally {
      setLoading(false);
    }

  }

  // ✅ Landing preview: same logic as handleConvert but WITHOUT credits gating
  const handleLandingPreviewConvert = async ({ mode, landingFile, landingJd }) => {
    if (!landingFile) return;

    setError("");
    setLoading(true);
    try {
    const detectedLang = cvLanguage;

    const form = new FormData();
    form.append("file", landingFile);
    form.append("language", detectedLang);
    form.append("job_description", mode === "match" ? (landingJd || "") : "");

    const res = await apiPost("/preview_pdf_with_jd", form, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 580000,
      responseType: "blob",
    });

    const blob = new Blob([res.data], { type: "application/pdf" });

    setPreviewPdfUrl((old) => {
      if (old) URL.revokeObjectURL(old);
      return URL.createObjectURL(blob);
    });

    // guests should never get a download url
    setDownloadUrl("");
  } catch (e) {
    console.error("Landing preview error", e);

    const detail =
      e?.response?.data?.detail ||
      e?.response?.data?.error ||
      e?.message ||
      e?.toString();

    setError(detail || "Preview failed.");
  } finally {
    setLoading(false);
  } 
  };

  const handleGenerate = async () => {
    if (!editedData) return
    setError(''); setLoading(true)
    try {
      if (!canUse) {
        setError(tUI(siteLanguage, 'msg_no_credits'))
        return
      }
      const payload = { ...editedData, language: cvLanguage }
      const res = await apiPost('/build_cv', payload, {
        headers: { 'Content-Type': 'application/json' }
      })
      setDownloadUrl(res.data.download_url)

      // ✅ refresh entitlements after success
      window.dispatchEvent(new Event('refresh-entitlements'))
      try { setEnt(await fetchEntitlements()) } catch {}
        } catch (e) {
      console.error("Build CV error", e);

      const detail =
        e?.response?.data?.detail ||
        e?.response?.data?.error ||
        e?.message ||
        e?.toString();

      setError(detail || 'Generation failed.');
    } finally {
      setLoading(false);
    }

  }

    const handleGenerateCoverLetter = async () => {
    // Only meaningful for AI Matching + Builder
    if (service === 'ai_matching' && !parsedData) return
    if (service === 'builder' && !editedData) return

    setError('')
    setCoverLoading(true)
    try {
      if (!canUse) {
        setError(tUI(siteLanguage, 'msg_no_credits'))
        return
      }

      let cvPayload
      let jobDescription = ''
      let language = cvLanguage

      if (service === 'ai_matching') {
        // Use parsed CV + the JD the user entered
        cvPayload = parsedData
        jobDescription = jd || ''
      } else {
        // Builder: use the edited CV from the editor
        cvPayload = editedData
      }

      const payload = {
        cv_data: cvPayload,
        language,
        job_description: jobDescription,
      }

      const res = await apiPost('/generate_cover_letter', payload, {
        headers: { 'Content-Type': 'application/json' }
      })

      const url = res.data?.download_url
          
      if (url) {
        // Create a hidden link and click it → generate + download in ONE click
        const link = document.createElement('a')
        link.href = url
        link.target = '_blank'
        link.rel = 'noopener noreferrer'
        // leave download empty so the browser uses the filename from S3
        link.download = ''
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }


      // refresh credits
      window.dispatchEvent(new Event('refresh-entitlements'))
      try { setEnt(await fetchEntitlements()) } catch {}
        } catch (e) {
      console.error("Cover letter error", e);

      const detail =
        e?.response?.data?.detail ||
        e?.response?.data?.error ||
        e?.message ||
        e?.toString();

      setError(detail || 'Cover letter generation failed.');
    } finally {
      setCoverLoading(false);
    }

  }

  // Landing: run Match JD preview using existing convert pipeline
// const handleLandingMatchPreview = async (landingFile, landingJd) => {
//     if (!landingFile) return;

//     // Use existing state + existing handler (no new business logic)
//     setFile(landingFile);
//     setJd(landingJd || "");
//     setService("ai_matching");
//     setOpenSection(null);

//     // Reset UI states (same pattern you already use)
//     setError("");
//     setDownloadUrl("");
//     setParsedData(null);
//     setEditedData(null);
//     setCoverLoading(false);

//     // Reuse existing Match JD pipeline (/debug_convert_cv + /convert_with_jd)
//     await handleConvert();
//   };
  // Landing: run Match JD preview WITHOUT sign-in (guest preview)
  const handleLandingMatchPreview = async (landingFile, landingJd) => {
    if (!landingFile) return;

    // Use the preview pipeline (no credits gating, no /debug_convert_cv)
    await handleLandingPreviewConvert({
      mode: "match",
      landingFile,
      landingJd,
    });
  };
  const handleLandingScanPreview = async (landingFile) => {
    await handleLandingPreviewConvert({
      mode: "scan",
      landingFile,
      landingJd: "",
    });
  };
  // Landing: Unlock downloads (single offer)
const handleLandingUnlock = async () => {
    if (!user) {
      if (typeof window !== "undefined" && window.gtag) {
        window.gtag("event", "unlock_requires_login", {
          page_path: window.location.pathname,
          language: siteLanguage,
        });
      }

      setShowAuthModal(true);
      return;
    }

    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "begin_checkout", {
        currency: "EUR",
        value: 24.99,
        plan: "premium",
        page_path: window.location.pathname,
        language: siteLanguage,
      });
    }

    // Single offer checkout
    await subscribe("premium");
  };

  const isStandalonePage =
  openSection === 'pricing' ||
  openSection === 'about' ||
  openSection === 'blog' ;
  




  return (
    <div className="App" lang={siteLanguage}>

      {/* ──────── Top Navigation ──────── */}
      <div className="top-bar">
        <div className="left-group">
          <button
            className={!openSection ? 'nav-item active' : 'nav-item'}
            onClick={() => goTo(null)}
          >
            {tUI(siteLanguage, 'nav_home')}
          </button>
        </div>

        <div className="center-group">
          <button
            className={openSection === 'about' ? 'nav-item active' : 'nav-item'}
            onClick={() => goTo(openSection === "about" ? null : "about")}

          >
            {tUI(siteLanguage, 'nav_about')}
          </button>

          
          <a
            href={getBlogUrl(siteLanguage)}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-item"
          >
            {tUI(siteLanguage, 'nav_blog')}
          </a>

          <button
            className={openSection === 'pricing' ? 'nav-item active' : 'nav-item'}
            onClick={() => goTo(openSection === "pricing" ? null : "pricing")}


          >
            {tUI(siteLanguage, 'nav_pricing')}
          </button>

          {!user ? (
            <button className="nav-item" onClick={() => setShowAuthModal(true)}>
              {tUI(siteLanguage, 'nav_signin')}
            </button>
          ) : (
            <button className="nav-item" onClick={() => signOut()}>
              {tUI(siteLanguage, 'nav_signout')}
            </button>
          )}
        </div>

        <div className="right-group">
          <LanguageSelector value={siteLanguage} onChange={setSiteLanguage} />
        </div>
      </div>
      {/* ─────────────────────────────── */} 

            {/* Panels */}
      {openSection === 'about'    && <About language={siteLanguage} />}
      {openSection === 'blog'     && <Blog language={siteLanguage} />}
      {openSection === 'pricing' && (
        <Pricing
          language={siteLanguage}
          user={user}
          hasActivePlan={hasActivePlan}
          ent={ent}
          onRequireAuth={() => setShowAuthModal(true)}
        />
      )}


      {/* HomeModern is ALWAYS rendered – navbar always visible.
          When isStandalonePage = true, HomeModern only shows the header. */}
      <HomeModern
        language={siteLanguage}
        file={file}
        setFile={setFile}
        service={service}
        onSelectService={(mode) => {
          if (!user) setShowAuthModal(true);
          else {
            setService(mode);
            setOpenSection(null);
            setError('');
            setDownloadUrl('');
            setParsedData(null);
            setEditedData(null);
            setDownloadUrl('');
            setParsedData(null);
            setEditedData(null);
            setCoverLoading(false);
            setPreviewPdfUrl('');

          }
        }}
        onConvert={handleConvert}
        canUse={canUse}
        loading={loading}
        error={error}
        user={user}
        onSignIn={() => setShowAuthModal(true)}
        onSignOut={signOut}
        setLanguage={setSiteLanguage}
        onOpenSection={(section) => goTo(section)}
        hasActivePlan={hasActivePlan}
        hasEverPaid={hasEverPaid}
        currentPlan={currentPlan}  
        hideMainContent={isStandalonePage}
        parsedData={parsedData}
        onLandingMatchPreview={handleLandingMatchPreview}
        onLandingUnlock={handleLandingUnlock}
        previewPdfUrl={previewPdfUrl}
        onClearPreview={() => setPreviewPdfUrl('')}
        blogUrl={getBlogUrl(siteLanguage)}
      />

            {/* Tools (ATS / AI Matching / Builder / Download) */}
      <>
        {/* ATS / AI Matching – hero-style card */}
        {(!openSection && (service === 'ats' || service === 'ai_matching')) && (
          <section className="mx-auto mt-8 mb-20 w-full max-w-[550px] px-4">
            <div className="rounded-xl border border-slate-200 p-5 shadow-sm bg-white">
              {/* Label + credits badge */}
              <div className="flex items-center justify-between mb-3 gap-3">
                <label className="block text-left text-[14px] font-medium text-slate-700">
                  {tUI(siteLanguage, 'hero_upload_label')}
                </label>
                <CreditsBadge language={siteLanguage} />
              </div>

              {/* File chooser row */}
              <div className="flex items-stretch overflow-hidden rounded-lg border border-slate-300">
                <label className="cursor-pointer whitespace-nowrap px-4 py-2 text-[14px] font-medium text-slate-900 bg-white hover:bg-slate-50">
                  <input
                    type="file"
                    accept="application/pdf"
                    className="hidden"
                    onChange={e => setFile(e.target.files?.[0] || null)}
                  />
                  Choose File
                </label>
                <span className="flex-1 px-4 py-2 text-left text-[14px] text-slate-600 bg-white border-l border-slate-300">
                  {file?.name || 'No file chosen'}
                </span>
              </div>

              {/* Job description for AI plan */}
              {service === 'ai_matching' && (
                <div className="mt-4 text-left">
                  <label className="block text-[14px] font-medium text-slate-700 mb-1">
                    {tUI(siteLanguage, 'label_job_desc')}
                  </label>
                  <textarea
                    className="w-full rounded-lg border border-slate-300 px-3 py-2 text-[14px] text-slate-900 focus:outline-none focus:ring-2 focus:ring-indigo-300"
                    rows={4}
                    value={jd}
                    onChange={e => setJd(e.target.value)}
                  />
                </div>
              )}

              {/* Main action button */}
              <button
                className="mt-4 w-full rounded-lg bg-[#061059] px-4 py-2.5 text-[16px] font-semibold text-white shadow-sm hover:bg-[#0A1575] focus:outline-none focus:ring-2 focus:ring-[#0A1575] disabled:opacity-60"
                onClick={handleConvert}
                disabled={!file || !canUse || loading}
              >
                {loading ? (
                  <span className="inline-flex items-center gap-2">
                    <ClipLoader size={16} />
                    <span>Working…</span>
                  </span>
                ) : service === 'ai_matching' ? (
                  tUI(siteLanguage, 'btn_convert_match')
                ) : (
                  tUI(siteLanguage, 'btn_convert')
                )}
              </button>

              {error && (
                <p className="mt-2 text-red-600 text-sm">
                  {error}
                </p>
              )}
            </div>
          </section>
        )}

        {/* Premium CV Builder */}
        {!openSection && user && ent?.status === 'active' && service === 'builder' && (
          <section className="mx-auto mt-10 mb-24 w-full max-w-[980px] px-4">
            <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
              {/* Header row: title + credits badge */}
              <div className="mb-4 flex items-center justify-between gap-3">
                <h2 className="text-[18px] font-semibold text-slate-900">
                  {tUI(siteLanguage, 'card_builder_title')}
                </h2>
                <CreditsBadge language={siteLanguage} />
              </div>

              {/* CV editor body */}
              <div className="builder-card-body">
                <CVEditor
                  data={parsedData || {}}
                  onChange={setEditedData}
                  language={cvLanguage}
                  onLanguageChange={setCvLanguage}
                />
              </div>

              {/* Generate button */}
              <div className="mt-6 flex justify-end">
                <button
                  onClick={handleGenerate}
                  disabled={!editedData || loading || !canUse}
                  className="inline-flex items-center justify-center rounded-lg bg-[#061059] px-6 py-2.5 text-[15px] font-semibold text-white shadow-sm hover:bg-[#0A1575] focus:outline-none focus:ring-2 focus:ring-[#0A1575] disabled:opacity-60"
                >
                  {loading ? (
                    <>
                      <ClipLoader
                        size={16}
                        className="mr-2 inline-block align-middle"
                      />
                      <span className="align-middle">Generating…</span>
                    </>
                  ) : (
                   tUI(siteLanguage, 'btn_generate_your_cv')  
                  )}
                </button>
              </div>

              {/* Error message */}
              {error && (
                <p className="mt-3 text-[13px] text-red-600">
                  {error}
                </p>
              )}
            </div>
          </section>
        )}

        {/* Download + Cover letter */}
        {/* Download + Cover letter */}
        {!openSection && downloadUrl && (
          <div className="download flex flex-col items-center gap-3">
            <a
              href={downloadUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="download-btn"
            >
              {tUI(siteLanguage, 'btn_download_cv')}
            </a>

            {(service === 'ai_matching' || service === 'builder') && (
              <button
                type="button"
                onClick={handleGenerateCoverLetter}
                disabled={coverLoading || !canUse}
                className="download-btn"
              >
                {coverLoading ? (
                  <>
                    <ClipLoader
                      size={16}
                      className="mr-2 inline-block align-middle"
                    />
                     {tUI(siteLanguage, 'btn_generate_cover_loading')}
                  </>
                ) : (
                  tUI(siteLanguage, 'btn_generate_cover')
                )}
              </button>
            )}
          </div>
        )}


      </>


      <footer className="py-8 bg-white border-t border-gray-200">
        <p className="footer-copy text-center text-slate-500 text-sm">© {new Date().getFullYear()} YourSmartCV — All rights reserved.</p>
      </footer>

      {/* Auth Modal */}
      {/* Auth Modal */}
      {showAuthModal && (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40 px-4">
          <div className="w-full max-w-md">
            <Authenticator variation="default" />
            {/* <Authenticator
              variation="default"
              onStateChange={(state) => {
                if (state === "signedIn") {
                  setShowAuthModal(false);
                  getCurrentUser().then(async (u) => {
                    setUser(u);
                    try {
                      setEnt(await fetchEntitlements());
                    } catch {}
                  });
                }
              }}
            /> */}
          </div>
        </div>
      )}
    </div>
  )
}
